export default __webpack_public_path__ + "static/media/480_store04-nl-mobile.2ea30804.png";